import { render, staticRenderFns } from "./sub-task.vue?vue&type=template&id=8dbc9976&scoped=true&"
import script from "./sub-task.vue?vue&type=script&lang=js&"
export * from "./sub-task.vue?vue&type=script&lang=js&"
import style0 from "./sub-task.vue?vue&type=style&index=0&id=8dbc9976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbc9976",
  null
  
)

export default component.exports